import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { GlobalService } from '../../global/global.service';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/catch';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Login } from './login-object.model';

@Injectable()
export class AuthService {

  // store the URL so we can redirect after logging in

  constructor(private http: HttpClient, private globalService: GlobalService) {
  }
  //url = this.globalService.urlMiPortal();
  url2 = this.globalService.urlContaE();
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  getToken() {
    return localStorage.getItem('key');
  }

  // public postLogin(jLog): Observable<any> {

  //   let obj = {
  //     username: jLog.username,
  //     password: jLog.password,
  //     applicationid: 5
  //   }
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(this.url + 'home/Login', json, { headers: this.headers })
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error.message);
  //     });

  // }

  postHeader(json) {
    return {
      headers: new HttpHeaders().set('Accept', 'application/json').set('Content-Type', 'application/json')
    };
  }

  // public login(login): Observable<any> {
  //   return this.postLogin(login); // Observable.of(true).delay(1000).do(val => this.isLoggedIn = true);
  // }

  // public logout(): Observable<any> {
  //   const obj = {
  //     UserToken: this.getToken()
  //   };
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(this.url + 'Home/Logoff', json, {headers: this.headers})
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error.error.message);
  //     });
  // }

  // public resetPassword(Email): Observable<any> {
  //   const obj = {
  //     UserToken: this.getToken(),
  //     Email: Email
  //   };
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(this.url + 'User/Password_Reset', json, {headers: this.headers})
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error.error.message);
  //     });
  // }

  // public confirmResetPassword(Code): Observable<any> {
  //   const obj = {
  //     UserToken: this.getToken(),
  //     Code: Code
  //   };
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(this.url + 'User/Password_Reset_Code', json, {headers: this.headers})
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error.error.message);
  //     });
  // }

  // public restPasswordNew(Code, Password, PasswordConfirm): Observable<any> {
  //   const obj = {
  //     Code: Code,
  //     Password: Password,
  //     PasswordConfirm: PasswordConfirm
  //   };
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(this.url + 'User/Password_Reset_New', json, {headers: this.headers})
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error.error.message);
  //     });
  // }

  // public PasswordFirstResetNewByToken(Password, PasswordConfirm): Observable<any> {
  //   const obj = {
  //     UserToken: this.getToken(),
  //     Password: Password,
  //     PasswordConfirm: PasswordConfirm
  //   };
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(this.url + 'User/Password_First_Reset_New_ByToken', json, {headers: this.headers})
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error.error.message);
  //     });
  // }

  // public aceptTerms(Id_Contract): Observable<any> {
  //   const obj = {
  //     UserToken: this.getToken(),
  //     Id_Contract: Id_Contract
  //   };
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(this.url2 + 'api/User/Contract_Accepted', json, {headers: this.headers})
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error.error.message);
  //     });
  // }

  // public signedContract(): Observable<any> {
  //   const obj = {
  //     UserToken: this.getToken(),
  //   };
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(this.url2 + 'api/User/Contract_Signed', json, {headers: this.headers})
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error.error.message);
  //     });
  // }

  // public resetPasswordToken(OldPassword, Password, PasswordConfirm): Observable<any> {
  //   const obj = {
  //     UserToken: this.getToken(),
  //     OldPassword: OldPassword,
  //     Password: Password,
  //     PasswordConfirm: PasswordConfirm
  //   };
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(this.url + 'User/Password_Reset_New_ByToken', json, {headers: this.headers})
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error.error.message);
  //     });
  // }

  // public terms(): Observable<any> {
  //   // tslint:disable-next-line:max-line-length
  //   return this.http.post<any>(this.url2 + 'api/User/Contract_Show', '', {headers: this.headers})
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error.message);
  //     });
  // }

  // public Get_Preferences_Notification_List_By_Token(token): Observable<any> {
  //   const obj = {
  //     UserToken: token,
  //   };
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(this.url + 'api/PreferencesNotification/Get_Preferences_Notification_List', json, {headers: this.headers})
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error.message);
  //     });
  // }

  // public Update_Preferences_Notification_By_Token(Id_Preferences_Notification, Value): Observable<any> {
  //   const obj = {
  //     UserToken: localStorage.getItem('key'),
  //     Id_Preferences_Notification: Id_Preferences_Notification,
  //     Value : Value
  //   };
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(this.url + 'api/PreferencesNotification/Update_Preferences_Notification_By_Token', json, {headers: this.headers})
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error.message);
  //     });
  // }

  // public Save_Preferences_Notification(): Observable<any> {
  //   const obj = {
  //     UserToken: localStorage.getItem('key'),
  //   };
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(this.url + 'api/PreferencesNotification/Save_Preferences_Notification', json, {headers: this.headers})
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error.message);
  //     });
  // }

  // public notifSysGen(): Observable<any> {
  //   const obj = {
  //     UserToken: localStorage.getItem('key')
  //   };
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(this.url + 'Notification_System/Notification_System_Generate', json, {headers: this.headers})
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error);
  //     });
  // }
}



// WEBPACK FOOTER //
// ./src/app/authentication/login/auth.service.ts